import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  grayScale,
  mHeader1,
  wArticle2,
  wHeader2,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;
  height: 636px;
  ${DESKTOP} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: initial;
    @media (max-width: 1152px) {
      width: 950px;
    }
  }
`;

export const MobileWrapper = styled.div`
  width: 328px;
  height: 250px;
  ${DESKTOP} {
    display: none;
  }
`;
export const DesktopWrapper = styled.div`
  display: none;
  ${DESKTOP} {
    display: block;
    width: 525px;
    height: 396px;
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;
  height: 360px;
  ${DESKTOP} {
    width: 410px;
    margin-right: 222px;
    @media (max-width: 1152px) {
      margin-right: 60px;
    }
  }
`;
export const Title = styled.h3`
  ${mHeader1};
  color: ${grayScale.white};
  ${DESKTOP} {
    ${wHeader2};
    color: ${grayScale.white};
    text-align: left;
    margin-bottom: 10px;
  }
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 328px;
  height: 224px;
  margin-top: 20px;
  p {
    color: #b4bfc6;
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 170%;
    margin-top: 0;
    ${DESKTOP} {
      ${wArticle2};
      color: #b4bfc6;
    }
  }

  ${DESKTOP} {
    justify-content: center;
    align-items: center;
    width: initial;
  }
`;
